import { kindDefinitions, SidebarGroup } from '../../domain/kindRegistry'
import { com } from '@eidu/form'
import EntityTypeKind = com.eidu.sharedlib.entity.type.EntityTypeKind

type SidebarSection = { id: string; title: string; kind: EntityTypeKind }

const buildSidebarSections = (group: SidebarGroup): readonly SidebarSection[] =>
  Object.values(kindDefinitions)
    .filter((d) => d.sidebarGroup === group)
    .map((d) => ({ id: d.sidebarSectionId, title: d.label, kind: d.kind }))

export const entitySidebarSections = buildSidebarSections('entity')
export const documentSidebarSections = buildSidebarSections('document')
export const assetSidebarSections = buildSidebarSections('asset')
